// Menu Drawer focusTrap
function getMenuFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "a[href], button:enabled"
    )
  ).filter(element => {
    return element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility !== 'hidden';
  });
}

const menuTrapFocusHandlers = {};

function menuTrapFocus(container, elementToFocus = container) {
  removeMenuTrapFocus();

  menuTrapFocusHandlers.focusin = (event) => {
    if (!container.contains(event.target) && event.target !== container) return;

    document.addEventListener('keydown', menuTrapFocusHandlers.keydown);
  };

  menuTrapFocusHandlers.focusout = function(event) {
    if (!container.contains(event.relatedTarget)) {
      document.removeEventListener('keydown', menuTrapFocusHandlers.keydown);
    }
  };

  menuTrapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    // Recalculate to account for open/closed submenus
    var elements = getMenuFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    if (!first || !last) return;

    // Handle focus remaining inside a hidden submenu
    if (!elements.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }

    // Last element: Tab forwards to first
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    // First element: Shift+Tab backwards to last
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', menuTrapFocusHandlers.focusout);
  document.addEventListener('focusin', menuTrapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeMenuTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', menuTrapFocusHandlers.focusin);
  document.removeEventListener('focusout', menuTrapFocusHandlers.focusout);
  document.removeEventListener('keydown', menuTrapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}



// Drawer menu system
const ddButtons = document.getElementsByClassName("mob-parent-button");

// Loop through each button
for (const ddButton of ddButtons) {
  ddButton.addEventListener("click", function (event) {
    event.preventDefault();
    updateDrawerScrollPosition();
    // Find the next sibling element and add the "active" class to it
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      updateSlHideVisibility();
    }
  });
} 

// Function - reset scroll position of drawer
function updateDrawerScrollPosition() {
  const Drawer = document.getElementById("mobNavDrawer");
  if (Drawer) {
    Drawer.scrollTop = 0;
  }
}

const ddPanels = document.querySelectorAll(".mob-secondary-level-ul, .mob-third-level-ul");

// Function - update the visibility of sl-hide divs
function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");

  for (const slHideDiv of slHideDivs) {
    if (isActivePanel) {
      slHideDiv.classList.add("sl-hide-oi");
    } else {
      slHideDiv.classList.remove("sl-hide-oi");
    }
  }
}

// Loop through each panel
for (const ddPanel of ddPanels) {
  // Find the "nav-secondary-fo-back-button" within the current panel
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");

  backButton.addEventListener("click", function () {
    // Find the parent menu link
    const parentButton = ddPanel.previousElementSibling;

    // Close the submenu
    ddPanel.classList.remove("active");
    updateSlHideVisibility();

    // Restore focus to the parent link
    if (parentButton?.matches(".mob-parent-button")) {
      parentButton.focus();
    }
  });

  // MutationObserver for each panel
  const panelObserver = new MutationObserver(() => {
    updateSlHideVisibility();
  });

  const observerConfig = { subtree: true, childList: true, attributes: true, characterData: true };
  panelObserver.observe(ddPanel, observerConfig);
}


// Accordion menu system

document.addEventListener("DOMContentLoaded", function () {
  var drawerAccordionButtons = document.querySelectorAll(".mob-parent-accordion-button");
  drawerAccordionButtons.forEach(function (drawerAccordionButton) {
    drawerAccordionButton.addEventListener("click", function () {
      var panel = drawerAccordionButton.nextElementSibling;

      // Toggle the "open" class for the accordion heading
      if (drawerAccordionButton.classList.contains("active")) {
        drawerAccordionButton.classList.remove("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'false');
        panel.style.height = null;
        setTimeout(function () {
          panel.classList.remove("panel-open");
          panel.setAttribute('aria-hidden', 'true');
        }, 600);
      } else {
        drawerAccordionButton.classList.add("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.scrollHeight + "px";
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add("panel-open");
      }
    });
  });
});


// Dropdown menu interaction
if (!document.querySelector('.nav-desktop-dd-btn-clickable')) {
  const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
  const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
  const gcHeader = document.querySelector('.header-bar-inner');
    
  function applyBackgroundColor() {
    gcHeader.classList.add('hovered');
  }
  
  function removeBackgroundColor() {
    gcHeader.classList.remove('hovered');
  }
  
  navDesktopButtons.forEach((navDesktopButton) => {
    navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
    navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
  });
  
  headerMegaFwLists.forEach((headerMegaFwList) => {
    headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
    headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
  });
}


// Scrolling transition for transparent header option
const headerDiv = document.getElementById('SiteHeader');
const hadHdrTransHpInitially = headerDiv.classList.contains('hdr-trans-hp');
const hasScrollBehaviour = headerDiv.querySelector('.hb-scroll-behaviour--scroll');

let isScrolled = false;

if (!hasScrollBehaviour) {
  function handleHeaderScroll() {
    const scrollPosition = window.pageYOffset;
    if (scrollPosition > 300 && !isScrolled) {
      headerDiv.classList.remove('hdr-trans-hp');
      isScrolled = true;
    } else if (scrollPosition <= 300 && isScrolled) {
      if (hadHdrTransHpInitially) {
        headerDiv.classList.add('hdr-trans-hp');
      }
      isScrolled = false;
    }
  }
  window.addEventListener('scroll', handleHeaderScroll);
  requestAnimationFrame(handleHeaderScroll);
}


// Menu drawer opening and closing
var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtns = document.querySelectorAll('.hdr-menu-button');
var navclose = document.getElementById('mobNavDrawerClose');
var lastFocusedButton = null;

// Function to open the menu drawer and set focus to the close button
function openMenuDrawer(event) {
  lastFocusedButton = event.currentTarget;
  navdrawermobile.classList.toggle('open');
  drawbg.classList.toggle('open');
  navbtns.forEach(function(button) {
    button.setAttribute('aria-expanded', 'true');
  });
  document.body.classList.toggle('body-lock-scroll');
  if (navdrawermobile.classList.contains('open')) {
    setTimeout(() => {
      menuTrapFocus(navdrawermobile);
    }, 50);
  }
  event.preventDefault();
}

// Event listeners to each menu button
navbtns.forEach(navbtn => {
  navbtn.addEventListener('click', openMenuDrawer);

  navbtn.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      openMenuDrawer(event);
    }
  });
});

if (navclose) { 
  navclose.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    document.body.classList.remove('body-lock-scroll');
    navbtns.forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
    removeMenuTrapFocus(lastFocusedButton);
  });
}

if (drawbg) { 
  drawbg.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    document.body.classList.remove('body-lock-scroll');
    navbtns.forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
    removeMenuTrapFocus(lastFocusedButton);
  });
}

// Close menu on Keyboard Escape
document.addEventListener('keydown', function(event) {
  const selectorOpen = document.querySelector(
    '.header-lang-selector-panel.open, .footer-lang-selector-panel.open'
  );

  if (event.key === 'Escape' && navdrawermobile?.classList.contains('open') && !selectorOpen) {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    document.body.classList.remove('body-lock-scroll');
    navbtns.forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
    removeMenuTrapFocus(lastFocusedButton);
  }
});



// Desktop dropdowns for click option
var panelBg = document.querySelector('.dd-click-drawer-bg');
var lastClickedButton = null;

document.querySelectorAll('.nav-desktop-dd-btn-clickable').forEach(item => {
  item.addEventListener('click', (event) => {
    event.preventDefault();

    const panel = item.nextElementSibling;
    const isSameButton = lastClickedButton === item;
    const gcHeader = document.querySelector('.header-bar-inner');

    // Hide all other panels
    document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(p => {
      if (p !== panel) {
        p.classList.remove("dd-visible");
      }
    });

    if (panel) {
      if (isSameButton) {
        // If clicking the same button, toggle the background visibility
        panel.classList.toggle("dd-visible");
        panelBg.classList.toggle("visible");
        gcHeader.classList.add('hovered');        
      } else {
        // If clicking a different button, ensure background stays visible
        panel.classList.add("dd-visible");
        panelBg.classList.add("visible");
        gcHeader.classList.add('hovered');
      }
    }

    // Update last clicked button
    lastClickedButton = isSameButton ? null : item;
  });
});

// Close all dropdowns when clicking anywhere outside
if (!document.querySelector('.nav-desktop-dd-btn-hover')) {
  document.addEventListener('click', (event) => {
    // Check if the clicked target is not inside a dropdown or clickable button
    if (
      !event.target.closest('.header-nav-desktop-dd-panel') &&
      !event.target.closest('.nav-desktop-dd-btn-clickable') &&
      !event.target.closest('.hdr-search-btn')
    ) {
      // Hide all dropdowns
      document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(panel => {
        panel.classList.remove("dd-visible");
        panelBg.classList.remove("visible");
        document.querySelector('.header-bar-inner').classList.remove('hovered');
      });
    }
  });
}